module.exports = __webpack_public_path__ + "media/img/payments/header-d3cdcaf9684b316525a50da354557c76.jpg";